import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import TabManager from "../tabManager/tabManager.js";
import TextInput from "../input/textinput.js";
import Button from "../../../../../server/public/shared/ui/inputs/classicButton.js";
import ResourceSelector from "../ResourceSelector/ResourceSelector.js";
import { getResourceUrl } from "../../../hooks/useResourcesList.js";
const modalContainer = document.querySelector("#wysiwg-modal-container");
export default function ImageComponent(props) {
    const { expanded, onChange } = props;
    const buttonRef = useRef();
    const modalRef = useRef();
    const prevY = useRef(0);
    const [imgSrc, setImgSrc] = useState("");
    const [width, setWidth] = useState("auto");
    const [height, setHeight] = useState("auto");
    const [alt, setAlt] = useState("");
    const [currentTab, setCurrentTab] = useState("url");
    function updatePos() {
        if (modalRef.current && buttonRef.current) {
            const box = buttonRef.current.getBoundingClientRect();
            const modalBox = modalRef.current.getBoundingClientRect();
            modalRef.current.style.top = `${box.y + box.width + 4}px`;
            const left = Math.min(box.x - (box.x > innerWidth / 2 ? modalBox.width - box.width : 0), innerWidth - modalBox.width - 16);
            modalRef.current.style.left = `${left}px`;
        }
    }
    function checkPos() {
        if (buttonRef.current) {
            const currentPos = buttonRef.current.getBoundingClientRect().y;
            if (currentPos != prevY.current)
                updatePos();
            prevY.current = currentPos;
        }
    }
    useEffect(() => {
        const timer = setInterval(checkPos, 100);
        return () => {
            clearInterval(timer);
        };
    }, []);
    useEffect(() => {
        updatePos();
    }, [expanded]);
    function addImageFromState() {
        let finalWidth = width;
        let finalHeight = height;
        if (width.length === 0 || height.length === 0 || imgSrc.length === 0) {
            return;
        }
        finalHeight += "px";
        finalWidth += "px";
        onChange(imgSrc, finalHeight, finalWidth, alt);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "rdw-option-wrapper", title: "Dodaj zdj\u0119cie", onClick: () => props.onExpandEvent(), ref: buttonRef },
            React.createElement("img", { src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=", alt: "" })),
        expanded &&
            createPortal(React.createElement("div", { ref: modalRef, onClick: (event) => {
                    event.stopPropagation();
                }, className: "rdw-image-modal custom-rdw-image-modal" },
                React.createElement(TabManager, { open: currentTab, onSetOpen: (newTab) => setCurrentTab(newTab), tabs: [
                        {
                            name: "url",
                            labelName: "URL zdjęcia",
                            content: (React.createElement("div", { className: "image-modal-source-container" },
                                React.createElement(TextInput, { label: "Adres URL", value: imgSrc, onChange: setImgSrc, disableExtraSpacing: true }))),
                        },
                        {
                            name: "resource",
                            labelName: "Z zasobów",
                            content: (React.createElement("div", { className: "image-modal-source-container" },
                                React.createElement(ResourceSelector, { state: undefined, onSelect: (file) => setImgSrc(getResourceUrl(file.name)) }))),
                        },
                    ] }),
                React.createElement("div", { className: "image-modal-dimension-inputs-container" },
                    React.createElement(TextInput, { label: "Szeroko\u015B\u0107", value: width, onChange: setWidth, disableExtraSpacing: true }),
                    React.createElement(TextInput, { label: "Wysoko\u015B\u0107", value: height, onChange: setHeight, disableExtraSpacing: true })),
                React.createElement(Button, { version: "classic", classNames: "image-modal-add-button", onClick: (event) => {
                        addImageFromState();
                    } }, "Dodaj")), modalContainer)));
}
